import { render, staticRenderFns } from "./stock-order-detail.vue?vue&type=template&id=11068866&"
import script from "./stock-order-detail.vue?vue&type=script&lang=js&"
export * from "./stock-order-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports